import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constants'
import { IExpirationDateConfigItem } from './type'

export const AddExpirationDateTypeModal = ({
  data,
  onClose,
}: {
  data: IExpirationDateConfigItem | null
  onClose: Function
}) => {
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs())

  useEffect(() => {
    if (!data) return
    const newInputs = cloneDeep(inputs)
    newInputs.title.value = data.title
    newInputs.days.value = data.days
    newInputs.isOnlyExpiredDate.value = data.type ? true : false
    newInputs.isSeasoning.value = data.seasonType ? true : false
    // newInputs.isCoBorrower.value = data[4] ? true : false
    newInputs.days.disabled = newInputs.isOnlyExpiredDate.value
    newInputs.calculateBasedOn.value = data.calculateBasedOn
    setInputs(newInputs)
  }, [])

  const onChange = (key: string, value: any) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    newInputs[key].error = ''
    if (key == 'isOnlyExpiredDate') newInputs.days.disabled = newInputs.isOnlyExpiredDate.value
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    const newInputs = cloneDeep(inputs)
    let values: Record<string, any> = {}
    let hasError = false
    Object.keys(inputs).forEach((key) => {
      if (inputs[key].visible === false) return null
      newInputs[key].error = InputValidate(newInputs[key])
      const { value, error } = newInputs[key]
      if (error) hasError = true
      values[key] = value
    })
    setInputs(newInputs)
    if (hasError) return false

    setLoading(true)
    await onClose({
      title: values.title,
      days: Number(values.days),
      type: values.isOnlyExpiredDate,
      seasonType: values.isSeasoning,
      calculateBasedOn: Number(values.calculateBasedOn) || 1,
      // isCoBorrower: values.isCoBorrower,
    })
    setLoading(false)
  }

  return (
    <Modal
      isOpen
      loading={isLoading}
      title={`${data ? 'Update' : 'Add'} Expiration Date`}
      titleOkay="Submit"
      onClose={() => onClose(null)}
      onOk={onSubmit}
    >
      <div className="w-128">
        {Object.keys(inputs).map((key) => {
          return (
            <div className="mb-4" key={key}>
              <RenderInput Key={key} input={inputs[key]} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
